import React from 'react';
import { authRoles } from 'app/auth';
import TermsOfService from './index';

export const TermsOfServiceConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  requireAuthentication: false,
  routes: [
    {
      path: '/terms-of-service',
      component: () => <TermsOfService />,
    },
  ],
};
